<template>
  <ShowLocation/>
  <ShowMap/>
</template>

<script>
import ShowLocation from './components/ShowLocation.vue'
import ShowMap from './components/ShowMap.vue'

export default {
  name: 'App',
  components: {
    ShowLocation,
    ShowMap
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
